import React from 'react';
import ReactDOM from 'react-dom/client';
import '@ant-design/v5-patch-for-react-19'; // Patch for React 19 compatibility
import 'antd/dist/reset.css'; // Import Ant Design CSS
import './styles/index.css'; // Import custom CSS with Tailwind
import App from './App.jsx';
import ErrorBoundary from './components/ErrorBoundary.jsx';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);
